﻿(function (angular) {
  "use strict";

  var BRIEF_TOAST_VISIBLE_DURATION_MS = 6000;

  angular.module("Toyota.Services").service("ToastManager", function () {
    var exports = this;

    var controller = null;

    exports.registerController = function (newController) {
      controller = newController;
    };

    exports.triggerBriefToast = function (message, group, hideOnDesktop, passthroughHtml) {
      return controller.addToast(message, BRIEF_TOAST_VISIBLE_DURATION_MS, group, hideOnDesktop, passthroughHtml);
    };

    exports.triggerForeverToast = function (message, group, hideOnDesktop, passthroughHtml) {
      return controller.addToast(message, null, group, hideOnDesktop, passthroughHtml);
    };

    exports.removeToast = function (toast) {
      controller.removeToast(toast);
    };

    exports.removeToastsByGroup = function (group) {
      controller.removeToastsByGroup(group);
    };

    return exports;
  });
})(window.angular);
